module.exports = __webpack_public_path__ + "img/sling-ball.4ccf879e.png";